import React from 'react';

import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OCardLayeredStandard as OCardLayeredStandardComp, AScrimGradientDirection } from '@marriott/mi-web-ui-kit';

import clsx from 'clsx';

import * as Styled from './OCardLayeredStandard.styles';

export const OCardLayeredStandardConfig = {
  emptyLabel: 'OCardLayeredStandard',

  isEmpty: () => true,

  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-card-layered-standard`,
};

/**
 * Default scrim used when AEM authoring does not supply `aScrimGradient`.
 * The Figma spec for this card always shows a bottom-to-top scrim behind the
 * text block so the eyebrow / headline / body remain readable over the image.
 */
const DEFAULT_SCRIM_GRADIENT = {
  direction: AScrimGradientDirection.BottomToTop,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OCardLayeredStandard = (props: any) => {
  const model = props.model || {};

  const { styleclass, componentId } = model;

  const aScrimGradient = props?.aScrimGradient ?? model.aScrimGradient ?? DEFAULT_SCRIM_GRADIENT;

  return (
    <Styled.Root
      data-testid="o-card-layered-standard-comp"
      data-component-name="o-card-layered-standard"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OCardLayeredStandardConfig} {...props}>
        <OCardLayeredStandardComp {...props} aScrimGradient={aScrimGradient} />
      </EditableComponent>
    </Styled.Root>
  );
};
